import axios from 'axios' 

const state = {
        
        animal:{
            name:'',
            sex:'',

        },
        animals: [],
    };

const getters = {
    animalList: state => state.users
};

const mutations = {
    addNewAnimal: (state, user) => state.animals.unshift(animal),
    removeAnimal: (state, user) => state.animals.shift(animal) 
};

const actions = {

    
};


export default {

    namespaced: true,
    state,
    getters,
    mutations,
    actions
   }
